import React, { useState, useEffect } from "react";
import "../Css/Events.css";
import ChapterMap from "../Components/ChapterMap";

import SeattlePhotos from "../Pages/SeattlePhotos";
import FremontPhotos from "../Pages/FremontPhotos";
import TriValleyPhotos from "../Pages/DublinPhotos";
import LosAngelesPhotos from "./LosAngelesPhotos";
import SanJosePhotos from "./SanJosePhotos";
import PhoenixPhotos from "./PhoenixPhotos";
import NewJerseyPhotos from "./NewJerseyPhotos";

const PREVIEW_COUNT = 3;

// ─── Inline icon ─────────────────────────────────────────────
const CloseIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 6L6 18M6 6l12 12" />
  </svg>
);

// ─── Modal: full photo gallery for one chapter ───────────────
const GalleryModal = ({ city, photos, onClose }) => {
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [onClose]);

  if (!city) return null;

  return (
    <div className="events-modal-overlay" onClick={onClose} role="presentation">
      <div
        className="events-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label={`${city} — full photo gallery`}
      >
        <button
          type="button"
          className="events-modal__close"
          onClick={onClose}
          aria-label="Close gallery"
        >
          <CloseIcon />
        </button>
        <h3 className="events-modal__title">{city}</h3>
        <div className="events-modal__body">
          <div className="events-gallery events-gallery--modal">
            {photos.map((item, index) => (
              <div className="events-image-wrapper" key={index}>
                <img
                  src={item.img}
                  alt={item.alt}
                  className="events-image"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

const Events = () => {
  const [activeCity, setActiveCity] = useState(null);

  const cityPhotos = {
    "Seattle, WA": SeattlePhotos,
    "Fremont, CA": FremontPhotos,
    "Tri-Valley, CA": TriValleyPhotos,
    "Los Angeles, CA": LosAngelesPhotos,
    "San Jose, CA": SanJosePhotos,
    "Phoenix, AZ": PhoenixPhotos,
    "New Jersey": NewJerseyPhotos,
  };

  return (
    <>
      <p className="events-tagline">
        Empowering healthier <span className="tagline-highlight">lives</span> through the rhythm of{" "}
        <span className="tagline-highlight-blue">table tennis</span>.
      </p>

      <ChapterMap
        chapters={Object.keys(cityPhotos)}
        onSelectChapter={setActiveCity}
      />

      {Object.keys(cityPhotos).map((city) => {
        const photos = cityPhotos[city];
        const preview = photos.slice(0, PREVIEW_COUNT);
        const hasMore = photos.length > PREVIEW_COUNT;

        return (
          <div className="events-section" key={city}>
            <h2 className="events-title">{city}</h2>

            <div className="events-gallery">
              {preview.map((item, index) => (
                <div className="events-image-wrapper" key={index}>
                  <img
                    src={item.img}
                    alt={item.alt}
                    className="events-image"
                    loading="lazy"
                  />
                </div>
              ))}
            </div>

            {hasMore && (
              <button
                type="button"
                className="events-explore-more"
                onClick={() => setActiveCity(city)}
              >
                Explore more
              </button>
            )}
          </div>
        );
      })}

      {activeCity && (
        <GalleryModal
          city={activeCity}
          photos={cityPhotos[activeCity]}
          onClose={() => setActiveCity(null)}
        />
      )}
    </>
  );
};

export default Events;